<template>
  <tooltip :text="text" :disabled="tooltipDisabled || text === label">
    <span :class="customClass" class="stringMax" :rbt-target="toCamel(`tagName ${text}`)">{{ label }}</span>
  </tooltip>
</template>

<script lang="ts">
import { defineComponent, computed } from "@vue/composition-api"
import Tooltip from "@/components/tooltip/TooltipRoot.vue"
import Utils from "@/utils/utils"

export default defineComponent({
  name: "StringMax",
  props: {
    text: {
      type: String,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    customClass: {
      type: String,
      default: ""
    },
    tooltipDisabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const label = computed(() => {
      if (props.text.length >= props.max) {
        return `${props.text.slice(0, props.max)}...`
      }
      return props.text
    })

    const toCamel = (name: string) => {
      return Utils.toCamel(name)
    }

    return {
      label,
      toCamel
    }
  },
  components: {
    Tooltip
  }
})
</script>
